import i18n from '@/i18n';

const handles = [
  {
    key: 'handleExit',
    name: '退出登录',
    async handler(vueInstance) {
      const { data: resData } = await vueInstance.$logina.post("/api/wxapp/h5Logout");
      if (resData.code == 200) {
        vueInstance.$toast.success(i18n.t('quitSuccessTips'));
        let url = localStorage.getItem("homeUrl");
        sessionStorage.removeItem("branchId");
        window.location.href = url;
      } else {
        vueInstance.$toast(resData.message);
      }
    },
  }, 
];
export default handles;

export const handleExecHandler = async (key, vueInstance) => {
  const handler = handles.find((item) => item.key === key);
  if (handler) {
    return await handler.handler(vueInstance);
  }
}